import React from 'react'
import * as Yup from 'yup'
import { useTranslation } from 'react-i18next'
import { Formik, Form } from 'formik'
import { FormGroup } from 'react-bootstrap'
import ATInput from '../../../common/formComponent/ATInput'
import ATTextButton from '../../../common/formComponent/ATTextButton'
import {
  EMAIL_LENGTH,
  PHONE_LENGTH,
  ROLE_NAME_LENGTH,
  USER_ACTION,
} from '../../../../utils/constants/UIConstants'
import {
  phoneRegExp,
  //validateEmailDomain,
} from '../../../../utils/constants/UIUtils'
import { useDispatch } from 'react-redux'
//import { useAddUserDetailsHooks } from '../../../../customHooks/usermanagement/useAddUserDetailsHooks'
import { UserDefaultData } from '../../../../interface/response/UserRolesResponse'
import { addUserData } from '../../../../redux/reducers/UserRolesReducer'
interface AddUserDetailsProps {
  initialValues: UserDefaultData
  continueButtonHandler: () => void
  onCloseModal: () => void
  isEdit: boolean
}

const AddUserDetails = ({
  initialValues,
  continueButtonHandler,
  onCloseModal,
  isEdit,
}: AddUserDetailsProps) => {
  const { t } = useTranslation(['translation'])
  const dispatch = useDispatch()
  //const { domainList } = useAddUserDetailsHooks()
  return (
    <div>
      <Formik
        validateOnMount={true}
        enableReinitialize
        initialValues={initialValues}
        validationSchema={Yup.object({
          userName: Yup.string()
            .required(t('form.required_field_message'))
            .min(
              ROLE_NAME_LENGTH.MIN,
              t('form.minimum_length_message', {
                length: ROLE_NAME_LENGTH.MIN,
              }),
            )
            .max(
              ROLE_NAME_LENGTH.MAX,
              t('form.maximum_length_message', {
                length: ROLE_NAME_LENGTH.MAX,
              }),
            ),
          phone: Yup.string()
            .matches(phoneRegExp, t('form.phone_invalid_message'))
            .max(
              PHONE_LENGTH.MAX,
              t('form.maximum_length_message', {
                length: PHONE_LENGTH.MAX,
              }),
            )
            .nullable(),
          email: Yup.string()
            .email(t('form.email_invalid_message'))
            .required(t('form.required_field_message'))
            .max(
              EMAIL_LENGTH.MAX,
              t('form.maximum_length_message', {
                length: EMAIL_LENGTH.MAX,
              }),
            ),
          // .test('domain', 'Invalid domain', function (value) {
          //   return validateEmailDomain(value, domainList)
          // }),
        })}
        onSubmit={(values) => {
          dispatch(
            addUserData({
              data: values,
              type: USER_ACTION.ADD_USER_INFO,
            }),
          )
          continueButtonHandler()
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isValid,
        }) => (
          <Form onSubmit={handleSubmit}>
            <div className="px-5 fw-bold pb-2">
              {t('userRoles.user_details')}
            </div>
            <div className="px-5">
              <FormGroup>
                <ATInput
                  label={t('userRoles.user_name')}
                  name="userName"
                  onChangeHandler={handleChange}
                  onBlurHandler={handleBlur}
                  value={values.userName}
                  isError={errors.userName && touched.userName}
                  error={errors.userName}
                  //disabled={isEdit}
                  placeholder={''}
                />
              </FormGroup>
              <FormGroup>
                <ATInput
                  label={t('userRoles.user_phone')}
                  name="phone"
                  onChangeHandler={handleChange}
                  onBlurHandler={handleBlur}
                  value={values.phone}
                  isError={errors.phone && touched.phone}
                  error={errors.phone}
                  //disabled={isEdit}
                  placeholder={''}
                  isMandatory={false}
                />
              </FormGroup>
              <FormGroup>
                <ATInput
                  label={t('userRoles.user_email')}
                  name="email"
                  onChangeHandler={handleChange}
                  onBlurHandler={handleBlur}
                  value={values.email}
                  isError={errors.email && touched.email}
                  error={errors.email}
                  disabled={isEdit}
                  placeholder={''}
                />
              </FormGroup>
            </div>
            <div className="d-flex px-5 py-3 justify-content-end">
              <div>
                <ATTextButton
                  title={t('common.cancel')}
                  onPressHandler={onCloseModal}
                  isFilledButton={false}
                />
              </div>
              <div>
                <ATTextButton
                  title={t('common.continue')}
                  onPressHandler={handleSubmit}
                  disabled={!isValid}
                />
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  )
}

export default AddUserDetails
